import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _JSON$stringify from 'babel-runtime/core-js/json/stringify';
import axios from './utils/axios';
import { utils } from 'gipsy-misc';
import listeners from './listeners';

var VALID_PROVIDERS = ['google', 'microsoft'];

var validateProvider = function validateProvider(provider) {
  if (!VALID_PROVIDERS.includes(provider)) {
    throw new Error('Invalid provider, must be one of ' + _JSON$stringify(VALID_PROVIDERS));
  }
};

export function getAuthURL(provider) {
  var forceConsent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var redirectUrl = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  validateProvider(provider);
  var url = '/oauth/' + provider + '/get-authurl';
  if (forceConsent) {
    url = utils.request.appendToUrl(url, { forceConsent: true });
  }
  if (redirectUrl) {
    url = utils.request.appendToUrl(url, { redirectUrl: redirectUrl });
  }
  return axios.get(url);
}

export var authenticate = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(provider, code, nonce, tz) {
    var redirectUrl = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
    var body, url, res, idToken, refreshToken;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            validateProvider(provider);
            body = code;
            url = '/oauth/' + provider + '/authenticate?nonce=' + nonce + '&timezone=' + tz;

            if (redirectUrl) {
              url = utils.request.appendToUrl(url, { redirectUrl: redirectUrl });
            }
            _context.next = 6;
            return axios.post(url, body);

          case 6:
            res = _context.sent;
            idToken = res.idToken, refreshToken = res.refreshToken;

            listeners.onTokenChange({ idToken: idToken, refreshToken: refreshToken });

            return _context.abrupt('return', res);

          case 10:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function authenticate(_x3, _x4, _x5, _x6) {
    return _ref.apply(this, arguments);
  };
}();

export var authenticateMobile = function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(provider, code, tz) {
    var body, url, res, idToken, refreshToken;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            validateProvider(provider);
            body = code;
            url = '/oauth/' + provider + '/mobile/authenticate?&timezone=' + tz;
            _context2.next = 5;
            return axios.post(url, body);

          case 5:
            res = _context2.sent;
            idToken = res.idToken, refreshToken = res.refreshToken;

            listeners.onTokenChange({ idToken: idToken, refreshToken: refreshToken });

            return _context2.abrupt('return', res);

          case 9:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function authenticateMobile(_x8, _x9, _x10) {
    return _ref2.apply(this, arguments);
  };
}();

export var signup = function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(provider, code, nonce, tz, invitationId) {
    var redirectUrl = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
    var body, url, res, idToken, refreshToken;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            validateProvider(provider);
            body = code;
            url = '/oauth/' + provider + '/signup?nonce=' + nonce + '&timezone=' + tz + '&invitationId=' + invitationId;

            if (redirectUrl) {
              url = utils.request.appendToUrl(url, { redirectUrl: redirectUrl });
            }
            _context3.next = 6;
            return axios.post(url, body);

          case 6:
            res = _context3.sent;
            idToken = res.idToken, refreshToken = res.refreshToken;

            listeners.onTokenChange({ idToken: idToken, refreshToken: refreshToken });

            return _context3.abrupt('return', res);

          case 10:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, this);
  }));

  return function signup(_x11, _x12, _x13, _x14, _x15) {
    return _ref3.apply(this, arguments);
  };
}();

export var incrementalOauth = function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(provider, code, nonce) {
    var redirectUrl = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    var body, url;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            validateProvider(provider);
            body = code;
            url = '/oauth/' + provider + '/incremental?nonce=' + nonce;

            if (redirectUrl) {
              url = utils.request.appendToUrl(url, { redirectUrl: redirectUrl });
            }
            return _context4.abrupt('return', axios.post(url, body));

          case 5:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, this);
  }));

  return function incrementalOauth(_x17, _x18, _x19) {
    return _ref4.apply(this, arguments);
  };
}();

export function signout() {
  var url = '/authenticate/signout';
  listeners.onTokenChange({ idToken: null, refreshToken: null });

  return axios.get(url);
}

export function get(tz) {
  var url = '/authenticate/session?timezone=' + tz;
  return axios.get(url);
}
//# sourceMappingURL=session.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-api/lib/session.js
// module id = 1084
// module chunks = 0